import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AclModule } from '@app/acl/acl.module';
import { TabsNavComponent } from '@app/pcs/shared/components/tab-nav/tabs-nav.component';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from 'pcs-component-library';

@NgModule({
  declarations: [
    TabsNavComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    IconModule,
    AclModule
  ],
  providers: [],
  exports: [
    TabsNavComponent
  ]
})
export class TabsNavModule { }
